import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/es';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import '../styles/calendario.css';
import config from '../config';

// Configurar moment en español
moment.locale('es');
const localizer = momentLocalizer(moment);

const CalendarioTurnos = () => {
  const [eventos, setEventos] = useState([]);
  const [vista, setVista] = useState('month');
  const [fecha, setFecha] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [eventoSeleccionado, setEventoSeleccionado] = useState(null);
  const [mostrarModalNuevo, setMostrarModalNuevo] = useState(false);
  const [fechaSeleccionada, setFechaSeleccionada] = useState(null);
  const [pacientes, setPacientes] = useState([]);
  const [nuevoTurno, setNuevoTurno] = useState({
    paciente_id: '',
    fecha_hora: '',
    duracion: 45,
    notas: ''
  });

  useEffect(() => {
    cargarTurnos();
    cargarPacientes();
  }, []);

  const cargarPacientes = async () => {
    try {
      const token = localStorage.getItem(config.tokenKey);
      const response = await fetch(`${config.apiUrl}/pacientes`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (!response.ok) throw new Error('Error al cargar pacientes');
      const data = await response.json();
      // Manejar respuesta paginada o array
      if (Array.isArray(data)) {
        setPacientes(data);
      } else if (data.data && Array.isArray(data.data)) {
        setPacientes(data.data);
      }
    } catch (error) {
      console.error('Error cargando pacientes:', error);
    }
  };

  const cargarTurnos = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem(config.tokenKey);
      const response = await fetch(`${config.apiUrl}/turnos`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) throw new Error('Error al cargar turnos');

      const data = await response.json();
      console.log('📦 Respuesta del backend:', data);
      
      // Manejar la estructura de respuesta del backend (paginada o array)
      let turnosArray = [];
      if (Array.isArray(data)) {
        turnosArray = data;
      } else if (data.data && Array.isArray(data.data)) {
        turnosArray = data.data;
      } else if (data.turnos && Array.isArray(data.turnos)) {
        turnosArray = data.turnos;
      } else {
        console.error('Formato de respuesta inesperado:', data);
        setEventos([]);
        return;
      }
      
      console.log('📋 Turnos a procesar:', turnosArray.length);
      
      // Convertir turnos a formato de eventos
      const eventosFormateados = turnosArray.map(turno => ({
        id: turno.id,
        title: `${turno.paciente_nombre || 'Paciente'} - ${turno.tipo || 'Consulta'}`,
        start: new Date(turno.fecha_hora),
        end: new Date(new Date(turno.fecha_hora).getTime() + 60 * 60 * 1000), // 1 hora por defecto
        resource: {
          id: turno.id,
          pacienteId: turno.paciente_id,
          pacienteNombre: turno.paciente_nombre,
          estado: turno.estado,
          tipo: turno.tipo,
          motivo: turno.motivo,
          profesional: turno.profesional_nombre,
          telefono: turno.paciente_telefono
        },
        // Colores según estado
        className: `evento-${turno.estado || 'pendiente'}`
      }));

      setEventos(eventosFormateados);
    } catch (error) {
      console.error('Error al cargar turnos:', error);
      alert('Error al cargar los turnos del calendario');
    } finally {
      setLoading(false);
    }
  };

  const handleSelectEvento = (evento) => {
    setEventoSeleccionado(evento);
    setMostrarModal(true);
  };

  const handleSelectSlot = ({ start, end }) => {
    // Abrir modal de nuevo turno con la fecha seleccionada
    const fechaFormateada = moment(start).format('YYYY-MM-DDTHH:mm');
    setFechaSeleccionada(start);
    setNuevoTurno({
      paciente_id: '',
      fecha_hora: fechaFormateada,
      duracion: 45,
      notas: ''
    });
    setMostrarModalNuevo(true);
  };

  const crearNuevoTurno = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem(config.tokenKey);
      const response = await fetch(`${config.apiUrl}/turnos`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...nuevoTurno,
          fecha_hora: nuevoTurno.fecha_hora + ':00'
        })
      });

      if (!response.ok) throw new Error('Error al crear turno');

      alert('Turno creado correctamente');
      setMostrarModalNuevo(false);
      setNuevoTurno({ paciente_id: '', fecha_hora: '', duracion: 45, notas: '' });
      cargarTurnos();
    } catch (error) {
      console.error('Error:', error);
      alert('Error al crear el turno');
    }
  };

  const cerrarModal = () => {
    setMostrarModal(false);
    setEventoSeleccionado(null);
  };

  const actualizarEstado = async (nuevoEstado) => {
    try {
      const token = localStorage.getItem(config.tokenKey);
      const response = await fetch(`${config.apiUrl}/turnos/${eventoSeleccionado.id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ estado: nuevoEstado })
      });

      if (!response.ok) throw new Error('Error al actualizar');

      alert('Estado actualizado correctamente');
      cerrarModal();
      cargarTurnos();
    } catch (error) {
      console.error('Error:', error);
      alert('Error al actualizar el turno');
    }
  };

  const eliminarTurno = async () => {
    if (!window.confirm('¿Estás seguro de eliminar este turno?')) return;

    try {
      const token = localStorage.getItem(config.tokenKey);
      const response = await fetch(`${config.apiUrl}/turnos/${eventoSeleccionado.id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) throw new Error('Error al eliminar');

      alert('Turno eliminado correctamente');
      cerrarModal();
      cargarTurnos();
    } catch (error) {
      console.error('Error:', error);
      alert('Error al eliminar el turno');
    }
  };

  // Personalizar colores de eventos según estado
  const eventStyleGetter = (event) => {
    let backgroundColor = '#3174ad';
    
    switch (event.resource?.estado) {
      case 'confirmado':
        backgroundColor = '#28a745';
        break;
      case 'cancelado':
        backgroundColor = '#dc3545';
        break;
      case 'completado':
        backgroundColor = '#6c757d';
        break;
      case 'pendiente':
        backgroundColor = '#ffc107';
        break;
      default:
        backgroundColor = '#3174ad';
    }

    return {
      style: {
        backgroundColor,
        borderRadius: '5px',
        opacity: 0.8,
        color: 'white',
        border: '0px',
        display: 'block'
      }
    };
  };

  // Mensajes en español
  const mensajes = {
    allDay: 'Todo el día',
    previous: 'Anterior',
    next: 'Siguiente',
    today: 'Hoy',
    month: 'Mes',
    week: 'Semana',
    day: 'Día',
    agenda: 'Agenda',
    date: 'Fecha',
    time: 'Hora',
    event: 'Turno',
    noEventsInRange: 'No hay turnos en este rango',
    showMore: total => `+ Ver más (${total})`
  };

  if (loading) {
    return (
      <div className="calendario-container">
        <div className="loading">Cargando calendario...</div>
      </div>
    );
  }

  return (
    <div className="calendario-container">
      <div className="calendario-header">
        <h1>📅 Calendario de Turnos</h1>
        <div className="calendario-actions">
          <button 
            className="btn-primary"
            onClick={() => {
              setNuevoTurno({
                paciente_id: '',
                fecha_hora: moment().format('YYYY-MM-DDTHH:mm'),
                duracion: 45,
                notas: ''
              });
              setMostrarModalNuevo(true);
            }}
          >
            ➕ Nuevo Turno
          </button>
          <button 
            className="btn-secondary"
            onClick={cargarTurnos}
          >
            🔄 Actualizar
          </button>
        </div>
      </div>

      <div className="calendario-leyenda">
        <span className="leyenda-item">
          <span className="color-box pendiente"></span> Pendiente
        </span>
        <span className="leyenda-item">
          <span className="color-box confirmado"></span> Confirmado
        </span>
        <span className="leyenda-item">
          <span className="color-box completado"></span> Completado
        </span>
        <span className="leyenda-item">
          <span className="color-box cancelado"></span> Cancelado
        </span>
      </div>

      <div className="calendario-wrapper">
        <Calendar
          localizer={localizer}
          events={eventos}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 700 }}
          views={['month', 'week', 'day', 'agenda']}
          view={vista}
          onView={setVista}
          date={fecha}
          onNavigate={setFecha}
          messages={mensajes}
          eventPropGetter={eventStyleGetter}
          onSelectEvent={handleSelectEvento}
          onSelectSlot={handleSelectSlot}
          selectable
          popup
          step={30}
          timeslots={2}
          min={new Date(2024, 0, 1, 8, 0)} // Inicio a las 8 AM
          max={new Date(2024, 0, 1, 20, 0)} // Fin a las 8 PM
        />
      </div>

      {/* Modal de detalles del turno */}
      {mostrarModal && eventoSeleccionado && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div className="modal-contenido" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>📋 Detalles del Turno</h2>
              <button className="btn-close" onClick={cerrarModal}>✕</button>
            </div>
            
            <div className="modal-body">
              <div className="detalle-item">
                <strong>Paciente:</strong>
                <span>{eventoSeleccionado.resource.pacienteNombre}</span>
              </div>
              
              <div className="detalle-item">
                <strong>Fecha y Hora:</strong>
                <span>{moment(eventoSeleccionado.start).format('DD/MM/YYYY HH:mm')}</span>
              </div>
              
              <div className="detalle-item">
                <strong>Tipo:</strong>
                <span>{eventoSeleccionado.resource.tipo || 'Consulta'}</span>
              </div>
              
              <div className="detalle-item">
                <strong>Estado:</strong>
                <span className={`badge badge-${eventoSeleccionado.resource.estado}`}>
                  {eventoSeleccionado.resource.estado}
                </span>
              </div>
              
              {eventoSeleccionado.resource.motivo && (
                <div className="detalle-item">
                  <strong>Motivo:</strong>
                  <span>{eventoSeleccionado.resource.motivo}</span>
                </div>
              )}
              
              {eventoSeleccionado.resource.telefono && (
                <div className="detalle-item">
                  <strong>Teléfono:</strong>
                  <span>{eventoSeleccionado.resource.telefono}</span>
                </div>
              )}
            </div>
            
            <div className="modal-footer">
              <div className="estado-buttons">
                {eventoSeleccionado.resource.estado !== 'confirmado' && (
                  <button 
                    className="btn-success"
                    onClick={() => actualizarEstado('confirmado')}
                  >
                    ✓ Confirmar
                  </button>
                )}
                
                {eventoSeleccionado.resource.estado !== 'completado' && (
                  <button 
                    className="btn-secondary"
                    onClick={() => actualizarEstado('completado')}
                  >
                    ✓ Completar
                  </button>
                )}
                
                {eventoSeleccionado.resource.estado !== 'cancelado' && (
                  <button 
                    className="btn-warning"
                    onClick={() => actualizarEstado('cancelado')}
                  >
                    ✕ Cancelar
                  </button>
                )}
              </div>
              
              <button 
                className="btn-danger"
                onClick={eliminarTurno}
              >
                🗑️ Eliminar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de nuevo turno */}
      {mostrarModalNuevo && (
        <div className="modal-overlay" onClick={() => setMostrarModalNuevo(false)}>
          <div className="modal-contenido" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>➕ Nuevo Turno</h2>
              <button className="btn-close" onClick={() => setMostrarModalNuevo(false)}>✕</button>
            </div>
            
            <form onSubmit={crearNuevoTurno} className="modal-body">
              <div className="form-group">
                <label>Paciente:</label>
                <select
                  value={nuevoTurno.paciente_id}
                  onChange={(e) => setNuevoTurno({...nuevoTurno, paciente_id: e.target.value})}
                  required
                >
                  <option value="">Seleccionar paciente</option>
                  {pacientes.map(p => (
                    <option key={p.id} value={p.id}>{p.nombre}</option>
                  ))}
                </select>
              </div>
              
              <div className="form-group">
                <label>Fecha y Hora:</label>
                <input
                  type="datetime-local"
                  value={nuevoTurno.fecha_hora}
                  onChange={(e) => setNuevoTurno({...nuevoTurno, fecha_hora: e.target.value})}
                  required
                />
              </div>
              
              <div className="form-group">
                <label>Duración:</label>
                <select
                  value={nuevoTurno.duracion}
                  onChange={(e) => setNuevoTurno({...nuevoTurno, duracion: parseInt(e.target.value)})}
                >
                  <option value={30}>30 minutos</option>
                  <option value={45}>45 minutos</option>
                  <option value={60}>60 minutos</option>
                </select>
              </div>
              
              <div className="form-group">
                <label>Notas:</label>
                <textarea
                  value={nuevoTurno.notas}
                  onChange={(e) => setNuevoTurno({...nuevoTurno, notas: e.target.value})}
                  rows="3"
                  placeholder="Notas adicionales..."
                />
              </div>
              
              <div className="modal-footer">
                <button type="submit" className="btn-primary">Guardar Turno</button>
                <button type="button" className="btn-secondary" onClick={() => setMostrarModalNuevo(false)}>Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default CalendarioTurnos;
